import { createContext } from "react";

export const ContactDetailsContext = createContext({
  liveChatProminenceExperiment: false,
  setLiveChatProminenceExperiment: () => {},
});
